<div id="iframe-container" className="default-iframe">
    <iframe id="lobby-iframe" title="lobby-iframe" scrolling="no" frameBorder="0" allowFullScreen width="100%" height="500px" src="{{src}}"></iframe>
</div>